import { render, staticRenderFns } from "./announcements_list.vue?vue&type=template&id=e132df88&scoped=true&"
import script from "./announcements_list.vue?vue&type=script&lang=js&"
export * from "./announcements_list.vue?vue&type=script&lang=js&"
import style0 from "./announcements_list.vue?vue&type=style&index=0&id=e132df88&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e132df88",
  null
  
)

export default component.exports